import { AiAssistantNotifyMicrophoneCommand } from '@dreryk/egabinet-ai-assistant-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

export type AiAssistantMicrophoneEvent = 'visitExited';

export const useAiAssistantNotifyMicrophone = (): UseCqrsCommandResult<void, AiAssistantMicrophoneEvent> => {
   return useCqrsCommand<void, AiAssistantMicrophoneEvent>(
      (event) => {
         const command = new AiAssistantNotifyMicrophoneCommand();
         command.event = event;
         return command;
      },
      {
         background: true,
      }
   );
};
